module.exports = __webpack_public_path__ + "img/gold.d68d2249.png";